import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Text from '@/components-latest/primitives/Text'
import Spinner from '@/components-latest/primitives/Spinner'

import Styles from './LoadingSpinner.module.scss'

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large'
  color?: 'default' | 'white'
  text?: string
  containerType?: 'inline' | 'centered' | 'fullPage'
  className?: string
  showText?: boolean
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  color = 'default',
  text,
  containerType = 'inline',
  className,
  showText = true
}) => {
  const { t } = useTranslation()

  const defaultText = t('common.loading', 'Loading...')
  const displayText = text || defaultText

  const containerClass = clsx(
    Styles.container,
    Styles[containerType],
    className
  )

  const spinnerClass = clsx(
    Styles.spinnerWrapper,
    showText && Styles.withText
  )

  return (
    <div className={containerClass}>
      <div className={spinnerClass}>
        <Spinner size={size} color={color} />
        {showText && (
          <Text className={Styles.loadingText} variant="body">
            {displayText}
          </Text>
        )}
      </div>
    </div>
  )
}

export default LoadingSpinner 